import classNames         from 'classnames';
import * as React         from 'react';
import { useTranslation } from 'react-i18next';
import DV                 from 'ts-data-validator';

const PageHeader = (props) => {
  const { t } = useTranslation();

  const {
          alt,
          bg,
          children,
          className,
          controlPanel,
          date,
          doubleBtns,
          headerClass,
          headerTitleClass,
          lockSystem,
          noBorder,
          schema,
          sku,
          transparent,
        } = props;

  const h1Schema     = React.useMemo(() => {
    if (!schema) {
      return {};
    }

    return { itemProp: 'name' };
  }, [schema]);
  const hasSmartLock = React.useMemo(() => {
    return !!lockSystem?.smartLock?.value;
  }, [lockSystem]);

  return (
    <section
      className={classNames('header', headerClass, {
        'no-border': noBorder,
        transparent,
      })}
    >
      {!DV.isUndefined(children) && (
        <h1
          {...h1Schema}
          className={classNames(className, headerTitleClass)}
        >
          {children}
            {hasSmartLock && (
              <span className={'smart-lock'}>
              {t('client_with_smart_lock_element')} {lockSystem.smartLock.value}
            </span>
            )}
            {sku && <small itemProp={'sku'}>{sku}</small>}
        </h1>
      )}
      {controlPanel}
      {transparent && DV.isString(bg) && (
        <picture>
          <img
            alt={children || alt || ''}
            src={`${bg}.png?w=1920&default=horizontal&t=${BUILD_TIME}`}
            sizes={`
              (max-width: 767px) 320px,
              (min-width: 768px) 992px,
              (min-width: 992px) 1152px,
              (min-width: 1440px) 1140px,
              1920px
            `}
            srcSet={`
              ${bg}.png?w=768&default=horizontal&t=${BUILD_TIME} 320w
              ${bg}.png?w=992&default=horizontal&t=${BUILD_TIME} 992w
              ${bg}.png?w=1152&default=horizontal&t=${BUILD_TIME} 1152w
              ${bg}.png?w=1440&default=horizontal&t=${BUILD_TIME} 1440w
              ${bg}.png?w=1920&default=horizontal&t=${BUILD_TIME} 1920w
            `}
          />
        </picture>
      )}
      {DV.isObject(doubleBtns) && doubleBtns}
      {!DV.isUndefined(date) && date}
      {schema && (
        <span
          itemProp={'brand'}
          style={{ display: 'none' }}
        >{t('steelline')}</span>
      )}
    </section>
  );
};

PageHeader.defaultProps = {
  title:       '',
  back:        false,
  tabs:        false,
  sku:         null,
  schema:      false,
  transparent: false,
  bg:          null,
  webp:        false,
  alt:         '',
};

export default PageHeader;
